const DEVELOPMENT = false;

export const TIME_LIMIT_MS = (DEVELOPMENT ? 10 : 2 * 60) * 1000;
export const HARD_CODED_BOARD = DEVELOPMENT
  ? [
      "W",
      "O",
      "V",
      "T",
      "R",
      "E",
      "S",
      "A",
      "S",
      "L",
      "L",
      "E",
      "I",
      "O",
      "T",
      "R",
    ]
  : [];

export const BOARD_SIZE = 4;
export const MIN_WORD_LENGTH = 4;

export const BLANK_CHARACTER = "-";

export const KEY_ENTER = "Enter";
export const KEY_SPACEBAR = " ";
